import React, { Component } from 'react';
import axios from 'axios';
import FacebookLogin from 'react-facebook-login';
import '../../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../../atoms/TextHeadingOne';
import TextParagraph from '../../atoms/TextParagraph';
// import DashboardPanelMenu from '../../molecules/DashboardPanelMenu';
import { ROOT_URL, APP_ID } from '../../../config/global.js';

//Returning the component
class FacebookConnect extends Component {
	constructor(props) {
		super(props);

		this.responseFacebook = this.responseFacebook.bind(this);
	}
	responseFacebook(response) {
        const facebookLoginRequest = axios({
            method: 'post',
            url: `${ROOT_URL}/api/facebook/login`,
            data: {
                accessToken: response.accessToken, //daniel@frankie.se
                facebookId: response.userID //12345
            }
        });

        facebookLoginRequest.then( (facebookPages) => {
			this.props.fetchPages();
        });
	}
	render() {
		return (
			<div className="dashboardPanelContainer">
				<div className="dashboardPanel">
					{/* <DashboardPanelMenu text='Menu' href='#' /> */}
					<div className="dashboardPanel__content">
						<div className="dashboardPanel__mainContent">
							<TextHeadingOne text={this.props.data.heading} />
							<TextParagraph text={this.props.data.text} />
							<FacebookLogin
								appId={APP_ID}
								cssClass="btn btn--small btn--iconLeft btn--fullWidthMobile"
								autoLoad={false}
								scope="manage_pages,pages_show_list,pages_messaging"
								fields=""
								callback={this.responseFacebook}
								icon={<i className='icon iconLeft fa fa-facebook-official'></i>}
								size="small"
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default FacebookConnect;





// WEBPACK FOOTER //
// ./src/redux/components/organisms/FacebookConnect/FacebookConnect.jsx